const defaults = {
  credentialId: '',
  operation: 'executeQuery',
  query: '',
  parameters: [],
  returnFirst: false,
  queries: [],
};

export default defaults;
